<!--
/*******************************************************************************
*@ 컴포넌트명   : AcnoSelectBox.vue
*@ 컴포넌트설명 : 계좌번호 컴포넌트
*@ 사용전문     : RBF0404F40 - 전계좌조회요약
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <select-box
    ref="acno"
    :value.sync="selected"
    :option-list="list"
    :label="label"
    :label-i18n="labelI18n"
    :disabled="disabled"
    :readonly="readonly"
    :default-text="defaultText"
    template="acno"
    v-bind:[this.required]="required"
  >
    <template #noData>
      <div class="notice normal">
        <div class="notice-tit">
          <p>{{/*선택할 수 있는 계좌가 없습니다.*/$t("MCOM-0000070")}}</p>
        </div>
        <div class="notice-cont">
          <p>{{/*다음과 같은 이유로 계좌가 표시되지 않습니다.*/$t("MCOM-0000071")}}</p>
          <ol class="olist olist-number-type info-guide">
            <li>
              <span class="num">①</span>
              {{/*출금 계좌로 등록된 계좌가 없는 경우*/$t("MCOM-0000072")}}
            </li>
            <li>
              <span class="num">②</span>
              {{/*거래 가능한 통화를 가진 계좌가 없는 경우*/$t("MCOM-0000073")}}
            </li>
            <!-- <li>
              <span class="num">③</span>기업 사용자의 경우 계좌 권한이 없는
              경우
            </li>-->
          </ol>
        </div>
      </div>
    </template>
  </select-box>
</template>
<script>
import { RBF0404F40 } from "@/mixins/wholAcnInq";
import { commonProps, valueProps, selectBoxProps } from "@/mixins/basicComponent";
export default {
  mixins: [RBF0404F40, commonProps, valueProps, selectBoxProps],
  props: {
    allOption: Boolean,
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
        this.$emit("update:detailValue", this.$refs.acno.selectedData);
        this.$emit("change", this.$refs.acno.selectedData);
      },
    },
  },
  data() {
    return {
      required: "",
    };
  },
  mounted() {
    if (this.$attrs) {
      for (const key in this.$attrs) {
        // let value = this.$attrs[key];
        if (!_.isNil(this[key])) {
          this[key] = this.$config[`VALIDATOR_${key.toUpperCase()}`];
        }
      }
    }
    if (this.selected != "") {
      this.setValue(this.selected);
    }
  },
  methods: {
    invalid() {
      this.$refs.acno.$v.selectedValue.$touch();
      return this.$refs.acno.isValidator ? this.$refs.acno.$v.$invalid : true;
    },
    init() {
      this.$refs.acno.init();
    },
    setValue(value) {
      this.$refs.acno.setValue(value);
    },
  },
};
</script>